export default __webpack_public_path__ + "static/media/ies_ChiaraCarucci.22213960.png";